export default "__VITE_PUBLIC_ASSET__ce70355b__"